var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c("ContentNav", {
        attrs: {
          hidden: _vm.hiddenNav,
          title: _vm.title,
          editBtn: _vm.editBtn,
          addBtn: _vm.addBtn,
          manageBtn: _vm.manageBtn,
          saveBtn: _vm.saveBtn,
          exportBtn: _vm.exportBtn,
          importBtn: _vm.importBtn,
          delBtn: _vm.forceDelBtn || (_vm.delBtn && _vm.editBtn),
        },
        on: { triger: _vm.onTriger },
        scopedSlots: _vm._u(
          [
            {
              key: "nav-actions",
              fn: function () {
                return [_vm._t("nav-actions")]
              },
              proxy: true,
            },
            {
              key: "appendTitle",
              fn: function () {
                return [_vm._t("appendTitle")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "v-container",
        {
          staticClass:
            "pa-0 ma-0 d-flex flex-row flex-nowrap justify-end align-center",
          class: _vm.filterable ? "pb-3" : "",
          attrs: { fluid: "" },
        },
        [_vm._t("top-selection", null, { filter: _vm.onFilter })],
        2
      ),
      _c(
        "v-card",
        {
          staticClass: "rounded-lg pa-0 ma-auto form-container",
          class:
            (_vm.$vuetify.breakpoint.mobile ? "" : _vm.widthClass) +
            " " +
            _vm.backgroundClass,
          attrs: { elevation: 0 },
        },
        [
          _c(
            "v-card-text",
            { class: _vm.backgroundClass + " pa-" + _vm.pad },
            [_vm._t("page-main")],
            2
          ),
          _vm._t("page-actions"),
        ],
        2
      ),
      _vm._t("tools-main"),
      _vm.importBtn && _vm.importOptions
        ? _c("ImportIn", {
            attrs: { show: _vm.showImport, options: _vm.importOptions },
            on: {
              close: function ($event) {
                _vm.showImport = false
              },
              import: function (e) {
                _vm.$emit("import", e)
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }